import * as React from "react";
import {Inventory} from "./inventory";
import {Category, Product, Shop} from "./types";
import {VendingViewHeader} from "./header";
import {classNames, layout, PushButton, View, ViewContent} from "@variocube/cube-ui";
import {stylesheet} from "typestyle";
import {useLocalization} from "../i18n";

interface VendInShopProps {
    shop: Shop;
    inventory: Inventory;
    product: Product;
    category: Category;
    onDone: () => void;
}

export function VendInShop(props: VendInShopProps) {
    const {t} = useLocalization();
    const {shop, category, product, onDone} = props;
    return (
        <View>
            <VendingViewHeader title={`${category.name} > ${product.name}`} onBack={onDone} />
            <ViewContent className={classNames(layout.vertical, layout.center, layout.alignCenter)}>
                <div className={classNames(layout.vertical, styles.info)}>
                    {shop.vendInShop || t("PaymentTerminalNotAvailable")}
                </div>
                <div className={layout.vertical}>
                    <PushButton primary onClick={onDone}>
                        {t("Close")}
                    </PushButton>
                </div>
            </ViewContent>
        </View>
    );
}

const styles = stylesheet({
    info: {
        paddingBottom: "1.5em",
        whiteSpace: "pre-wrap"
    }
});
